import { render, staticRenderFns } from "./MergeGoods.vue?vue&type=template&id=eb3a3346&scoped=true"
import script from "./MergeGoods.vue?vue&type=script&lang=js"
export * from "./MergeGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb3a3346",
  null
  
)

export default component.exports